import { getAuthDataCall, postAuthDataCall, deleteAuthDataCall } from '../utils';
import axios from 'axios';

export const getCoursesList = async () => {
    const resp = await getAuthDataCall(`/v1/course_instructor`);
    return resp;
};

export const addToCart = async (payload) => {
    const resp = await postAuthDataCall('/auth/carts', payload);
    return resp;
};

export const getCartDetails = async () => {
    const resp = await getAuthDataCall('/auth/carts');
    return resp;
};

export const getCartCount = async () => {
    const resp = await getAuthDataCall('auth/cart_count');
    return resp;
};
export const deleteProductCart = async (id) => {
    const resp = await deleteAuthDataCall(`auth/carts/${id}`);
    return resp;
};
export const emptyUserCart = async () => {
    const resp = await deleteAuthDataCall('/auth/emptyCart');
    return resp;
};

export const addToWishList = async (payload) => {
    const resp = await postAuthDataCall('/auth/wishLists', payload);
    return resp;
};

export const getWishlist = async () => {
    const resp = await getAuthDataCall('/auth/wishLists');
    return resp;
};

export const deleteWishlist = async (id) => {
    const resp = await deleteAuthDataCall(`auth/wishLists/${id}`);
    return resp;
};
